export const rules = {
    required: (value: any) => !!value || 'โปรดระบุข้อมูล',
    pid: (value: any) => value.length == 13 || 'โปรดระบุเลข 13 หลัก',
    email: (value: any) => {
        //if (/.+@.+\..+/.test(value)) return true
        //return 'E-mail ไม่ถูกต้อง'
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return !value || pattern.test(value) || 'E-mail ไม่ถูกต้อง'
    },
}